import React from 'react';
import { Box, Grid, Stack, Typography } from '@mui/material';
import Section from '../shared/Section';
import SectionHeading from '../shared/SectionHeading';
import shilpiPortrait from './shilpi_small.png';
import anikaPortrait from './anika_small.png';
import './Experience.css';

const teamMembers = [
  {
    name: 'Shilpi Ghildiyal',
    role: 'CEO / Daglig Leder',
    photo: shilpiPortrait,
  },
  {
    name: 'Anika Sawant',
    role: 'Customer Experience Specialist',
    photo: anikaPortrait,
  },
];

const Experience = () => {
  return (
    <Section background='#FFFFFF'>
      <Stack spacing={6}>
        <SectionHeading
          eyebrow='Our Team'
          title='The people crafting the FoodFe experience'
          description='Founders, chefs, and technologists collaborate daily to evolve FoodFe’s zero-waste platform and keep every dining moment purposeful and measurable.'
          align='center'
        />
        <Grid container spacing={4} justifyContent='center'>
          {teamMembers.map((member) => (
            <Grid item xs={12} md={6} key={member.name}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', md: 'row' },
                  gap: { xs: 3, md: 4 },
                  backgroundColor: '#FFFFFF',
                  borderRadius: 28,
                  border: '1px solid rgba(47, 58, 114, 0.08)',
                  boxShadow: '0px 24px 48px rgba(31, 36, 51, 0.08)',
                  overflow: 'hidden',
                  p: { xs: 3, md: 4 },
                  height: '100%',
                }}
              >
                <Box
                  sx={{
                    flexBasis: { xs: '100%', md: '46%' },
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 200, md: 220 },
                      height: { xs: 220, md: 240 },
                      borderRadius: '50%',
                      backgroundColor: '#FFFFFF',
                      border: '1px solid rgba(47, 58, 114, 0.08)',
                      display: 'grid',
                      placeItems: 'center',
                      overflow: 'hidden',
                      boxShadow: '0px 18px 36px rgba(31, 36, 51, 0.12)',
                    }}
                  >
                    <Box
                      component='img'
                      src={member.photo}
                      alt={member.name}
                      sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        backgroundColor: '#FFFFFF',
                      }}
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    textAlign: { xs: 'center', md: 'left' },
                  }}
                >
                  <Typography variant='h4' sx={{ mb: 1 }}>
                    {member.name}
                  </Typography>
                  <Typography variant='subtitle1' color='text.secondary'>
                    {member.role}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Section>
  );
};

export default Experience;
